import { fetch2, get, baseURL } from "./api";
import { ChromeCache } from "@/libs/ChromeCache";
import {
  getLinkedinCompanyByUniversalName,
  // getLinkedinCompanyByUrn,
  // getLinkedinProfileByGraphql,
  getLinkedinProfile,
  // getLinkedinProfileContactInfo,
} from "./linkedin";
import type { ContactListInfo, BatchFindInfo } from "@/types/contact";
import { LinkedinUrl } from "@/config";

const chromeCacheTtl = 1000 * 60 * 60 * 24;

export async function getContactInfo(publicId: string) {
  const chromeCacheKey = `lp_${publicId}` as const;
  const cachedData = await ChromeCache.get(chromeCacheKey);
  if (cachedData) {
    return cachedData;
  }

  const entityProfile = await getLinkedinProfile(publicId);
  // const profileContactInfo = await getLinkedinProfileContactInfo(publicId);
  // const graphqlProfile = await getLinkedinProfileByGraphql(publicId);

  const params: any = {
    publicId,
    // profileContactInfo,
  };
  // if (contactInfo) {
  //   // console.log("contactInfo", contactInfo);
  //   params.webInfo = { ...contactInfo };
  // }
  if (entityProfile) {
    params.entityProfile = { ...entityProfile };
    // params.graphqlProfile = { ...graphqlProfile };
  }

  return fetch2(baseURL + "/api/contact/search_user", params, {
    // chromeCacheKey: chromeCacheKey,
    // needCache: true,
  }).then((res) => {
    if (res.code === 200) {
      if (res.data.firstName || res.data.lastName) {
        ChromeCache.set(chromeCacheKey, res, { ttl: chromeCacheTtl });
      }
      return res;
    }
    return null;
  });

  // if (contactInfo) {
  //   const result = {
  //     code: 200,
  //     data: contactInfo,
  //   };
  //   ChromeCache.set(chromeCacheKey, result, { ttl: 1000 * 60 * 60 * 24 });
  //   return result;
  // }
}

// export async function getCompanyInfoByUrn(urn: string) {
//   const chromeCacheKey = `lc_urn_${urn}` as const;
//   const cachedData = await ChromeCache.get(chromeCacheKey);
//   if (cachedData) {
//     return cachedData;
//   }

//   const companyInfo = await getLinkedinCompanyByUrn(urn);
//   if (!companyInfo) {
//     return null;
//   }

//   fetch2(
//     baseURL + "/api/contact/search_company",
//     {
//       companyInfo,
//     },
//     undefined
//     // true
//   ).then((res) => {
//     if (res.code === 200) {
//       // ChromeCache.set(chromeCacheKey, res, { ttl: chromeCacheTtl });
//       // const universalName: string = res.data.universalName;
//       // if (universalName) {
//       //   ChromeCache.set(`lc_un_${universalName}`, res, {
//       //     ttl: chromeCacheTtl,
//       //   });
//       // }
//       return res;
//     }
//     return null;
//   });

//   const data = {
//     universalName: companyInfo.universalName,
//     urn: companyInfo.entityUrn.split(":").pop(),
//     name: companyInfo.name,
//   };

//   ChromeCache.set(
//     chromeCacheKey,
//     { code: 200, data: data },
//     { ttl: chromeCacheTtl }
//   );
//   ChromeCache.set(
//     `lc_un_${data.universalName}`,
//     { code: 200, data: data },
//     { ttl: chromeCacheTtl }
//   );
//   return { code: 200, data };
// }

export async function getCompanyInfoByUniversalName(universalName: string) {
  const chromeCacheKey = `lc_${universalName}` as const;
  const cachedData = await ChromeCache.get(chromeCacheKey);
  if (cachedData) {
    return cachedData;
  }

  const companyInfo = await getLinkedinCompanyByUniversalName(universalName);
  if (!companyInfo) {
    return null;
  }

  return fetch2(baseURL + "/api/contact/search_company", {
    companyInfo,
  }).then((res) => {
    if (res.code === 200) {
      const data = {
        universalName: companyInfo.universalName,
        name: companyInfo.name,
      };
      res.data = Object.assign({}, res.data, data);
      ChromeCache.set(chromeCacheKey, res, { ttl: chromeCacheTtl });
      return res;
    }
    return null;
  });
}

export async function getSearchRecord(params: {
  publicId: string;
  companyUniversalName?: string;
}) {
  const companyUrl = params.companyUniversalName
    ? LinkedinUrl + "/company/" + params.companyUniversalName
    : "";

  return fetch2<{
    findEmailFlag: boolean;
    historyEmail: {
      company: string;
      title: string;
      sources: {
        name: string;
        email: string;
        source: string;
        valid: true;
      }[];
      quotaDeducted: false;
      useCache: false;
      public_id: string;
      first_name: string;
      last_name: string;
    };
    findPhoneFlag: true;
    historyPhone: {
      public_id: string;
      first_name: string;
      last_name: string;
      sources: {
        name: string;
        phone: string;
        source: string;
        valid: boolean;
      }[];
    };
    findKpFlag: false;
  }>(
    baseURL + "/api/contact/search_history",
    {
      ...params,
      companyUrl,
    },
    undefined,
    true
  );
}

// 获取联系人信息
// export function getContact(params: { publicId: string; companyUrl?: string }) {
//   return fetch2(
//     baseURL + "/api/contact/search" + "?publicId=" + params.publicId,
//     params,
//     undefined,
//     true
//   );
// }

// export function getSummary(params: { publicId: string }) {
//   // return new Promise(function (resolve) {
//   //   setTimeout(() => {
//   //     resolve({
//   //       code: 200,
//   //       data: "**Basic Information**\n\n🔹 **Name:** Finn Christoffer Kurniawan\n🔹 **Location:** Bandung, West Java, Indonesia\n🔹 **Industry:** Information Technology & Services\n🔹 **Occupation:** iOS Developer at nbs.co.id\n🔹 **LinkedIn URL:** [Finn Christoffer](https://www.linkedin.com/in/finnchristoffer/)\n🔹 **Skills:** iOS Development, Swift (Programming Language), RxSwift, Realm Database\n🔹 **Education:** Apple Developer Academy Graduate\n\n---\n\n**Company Introduction**\n\nFinn is currently working with [nbs.co.id](https://nbs.co.id/), a company based in Jakarta, Indonesia. The company operates within the Information Technology and Services industry.\n\n---\n\n**Career Overview**\n\nFinn brings a solid year of industry experience as an iOS Developer. With a strong emphasis on continuous learning and adaptability, Finn has been recognized with the prestigious WWDC Scholarship in 2022 and has been certified as an \"iOS Developer Expert\" by Dicoding. Backed by a strong educational foundation in Computer Science and a passion for application development, Finn excels in team environments and demonstrates strong critical thinking skills. Powered by a tireless work ethic and an insatiable curiosity, Finn is prepared to provide significant contributions to any iOS development team.\n\n---\n\n**Sales Strategies**\n\n🟢 Understanding Finn's professional needs: With his focus on iOS development, we can offer solutions tailored to his specific field of expertise. This could include new development tools, software upgrades, or opportunities for furthering his knowledge in this field.\n\n🟢 Connecting with his interests: As Finn has a passion for learning and adaptability, we can present our products or services in a way that aligns with this. This could include showing how our solutions are innovative or can adapt to the changing needs of the tech industry.\n\n🟢 Highlighting his achievements: Acknowledging the hard work Finn has put into his career can foster a connection. By recognizing his WWDC Scholarship and his certification as an iOS Developer Expert, we can show that we appreciate and understand his professional journey. Moreover, we can showcase how our solutions can contribute to his ongoing success.",
//   //     });
//   //   }, 1000);
//   // });
//   return fetch2(baseURL + "/api/contact/summary", params);
// }

// 获取联系人状态，如是否已经同步过
export function getContactStatus(params: { publicId: string }) {
  return fetch2(baseURL + "/api/contact/info", params, undefined, true);
}

export function findPhone(params: any = {}) {
  // return new Promise(function (resolve) {
  //   setTimeout(() => {
  //     const random = Math.random();
  //     // console.log(random);
  //     // resolve({
  //     //   code: 4020001,
  //     //   msg: "",
  //     //   data: {},
  //     // });
  //     // return;
  //     if (random > 0.6) {
  //       console.log("IN_PROGRESS");
  //       resolve({
  //         code: 202,
  //         msg: "",
  //         data: {
  //           progress: "IN_PROGRESS",
  //           publicId: "123",
  //           firstName: "John",
  //           lastName: "Doe",
  //         },
  //       });
  //     } else {
  //       console.log("COMPLETE");
  //       resolve({
  //         code: 200,
  //         msg: "",
  //         data: {
  //           progress: "COMPLETE",
  //           publicId: "123",
  //           firstName: "John",
  //           lastName: "Doe",
  //           sources:
  //             (random < 0.3 || true)
  //               ? [
  //                   {
  //                     name: "apollo",
  //                     phone: "+1 650-253-0000",
  //                     source: "https://linkedin.io/",
  //                     valid: true,
  //                   },
  //                 ]
  //               : [],
  //         },
  //       });
  //     }
  //   }, 5000);
  // });
  return fetch2<
    | any
    | {
        progress: "COMPLETE";
        publicId: string;
        firstName: string;
        lastName: string;
        spend: number;
        sources: {
          name: string;
          phone: string;
          source: string;
          valid: boolean;
        }[];
      }
  >(baseURL + "/api/contact/findPhone", params, undefined, true);
}

export function findEmail(params: any = {}) {
  // return new Promise(function (resolve) {
  //   setTimeout(() => {
  //     resolve({
  //       code: 200,
  //       msg: "",
  //       data: {
  //         sources: [
  //           {
  //             email: "yutang.sheng@atmecs4.com",
  //             name: "linkedin",
  //             source: "https://linkedin.io/",
  //             valid: true,
  //           },
  //           {
  //             name: "hunter",
  //             valid: true,
  //             email: "www.nova@gmail.com",
  //             source: "http://www.hunter.com",
  //           },
  //           {
  //             name: "apollo",
  //             valid: true,
  //             email: "www.nova@gmail.com",
  //             source: "http://www.apollo.com",
  //           },
  //           {
  //             name: "apollo",
  //             valid: true,
  //             email: "apollo@gmail.com",
  //             source: "http://www.apollo.com",
  //           },
  //           {
  //             name: "snov",
  //             valid: true,
  //             email: "snov@gmail.com",
  //             source: "http://www.snov.com",
  //           },
  //           {
  //             name: "dropcontact",
  //             valid: false,
  //             email: "dropcontact@gmail.com",
  //             source: "http://www.drop.com",
  //           },
  //         ],
  //       },
  //     } as const);
  //   }, 800);
  // });

  return fetch2<{
    spend: number;
    sources: {
      name: string;
      email: string;
      source: string;
      valid: boolean;
    }[];
  }>(baseURL + "/api/contact/findEmailAll", params);
}

export function leadsConditions(params: any = {}) {
  return fetch2<{
    message: {
      content: {
        text: string;
      };
    };
  }>(baseURL + "/api/contact/leadsConditions", params, undefined, true);
}

export function findLeads(params: any = {}) {
  return fetch2<{
    records: {
      name: string;
      email: string;
      source: string;
      valid: boolean;
    }[];
  }>(baseURL + "/api/contact/findLeads", params);
}

export function findKp(params: any = {}) {
  return fetch2<{
    records: {
      name: string;
      email: string;
      source: string;
      valid: boolean;
    }[];
    userEventId: string;
  }>(baseURL + "/api/contact/findKP", params);
}

export function queryEmailStatus(params: any = {}) {
  return get(baseURL + "/api/contact/batch/status", params, undefined, false);
}

// export function findEmail(params: any = {}) {
//   return fetch2(baseURL + "/api/contact/findEmail", params);
// }

export function queryLeadDetail(params: any = {}) {
  return get(baseURL + "/api/contact/leadDetail", params, undefined, false);
}
export function contactSync(params: any = {}) {
  return fetch2(baseURL + "/api/contact/sync", params, undefined, false);
}

export function contactExport(params: any = {}) {
  return fetch2(
    baseURL + "/api/contact/export",
    params
  ) as unknown as Promise<Blob>;
}

export type ContactCsvExportParams = {
  exportAll: boolean;
  scene: string;
  selectedIds?: string[];
};

export type ContactCsvExportResult = {
  blob: Blob;
  filename: string;
};

const getExportFilename = (contentDisposition: string) => {
  const encodedFilename = contentDisposition.match(
    /filename\*=UTF-8''([^;]+)/i,
  )?.[1];
  if (encodedFilename) {
    try {
      return decodeURIComponent(encodedFilename.replace(/["']/g, ""));
    } catch {
      return encodedFilename.replace(/["']/g, "");
    }
  }

  return (
    contentDisposition.match(/filename="?([^";]+)"?/i)?.[1]?.trim() ||
    "export.csv"
  );
};

export async function exportContactCsv(
  params: ContactCsvExportParams,
  timeout = 60_000,
): Promise<ContactCsvExportResult> {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), timeout);

  try {
    const response = await fetch(baseURL + "/api/contact/exportContactCsv", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(params),
      signal: controller.signal,
    });

    if (!response.ok) {
      throw new Error(`Export request failed: ${response.status}`);
    }

    return {
      blob: await response.blob(),
      filename: getExportFilename(
        response.headers.get("content-disposition") || "",
      ),
    };
  } finally {
    window.clearTimeout(timeoutId);
  }
}

export function contactBatchSync(params: any = {}) {
  return fetch2(baseURL + "/api/contact/batchSync", params, undefined, true);
}
export function queryBatchStatus(userEventId: string) {
  return fetch2(
    baseURL + `/api/contact/batch/status?userEventId=${userEventId}`
  );
}

export function exportContact(params: any = {}) {
  // return delayExecution(
  //   () => ({
  //     code: 200,
  //   }),
  //   2000
  // );
  return fetch2(
    baseURL + "/api/contact/exportContact",
    params,
    undefined,
    false
  );
}

export function checkContactExported(params: { publicId: string }) {
  // return Promise.resolve({
  //   code: 200,
  //   data: 1,
  // });
  return fetch2(baseURL + "/api/contact/checkExported", params);
}

// 查询用户导出过的联系人
export function contactListContact(params: any = {}) {
  return fetch2<ContactListInfo>(baseURL + `/api/contact/listContact`, params);
}

// 删除联系人
export function deleteContact(params: { ids: Array<string | number> }) {
  return fetch2(baseURL + `/api/contact/delete`, params);
}

// 批量查找邮箱
export function batchFindEmailAll(params: any = {}) {
  return fetch2<BatchFindInfo>(
    baseURL + `/api/contact/batchFindEmailAll`,
    params
  );
}

// 批量查找手机号
export function batchEnrichPhoneAll(params: any = {}) {
  return fetch2<BatchFindInfo>(
    baseURL + `/api/contact/batchEnrichPhoneAll`,
    params
  );
}

// 批量同步联系人
// export function batchSync(
//   params: any = {},
// ): ResponseType<BatchFindInfo> {
//   return fetch2(baseURL + `/api/contact/batchSync`, params);
// }

// 联系人列表批量查询轮询结果
export function contactGetBatchInfo(params: any = {}) {
  return fetch2(baseURL + `/api/contact/getBatchInfo`, params);
}

export type TDefaultTitleGroup = {
  cacheIndex: number;
  groupName: string;
  id: string;
  titleType: number;
  titles: string;
  userId: string;
};

// 查询全局词库
export function defaultTitleGroup(params: any = {}) {
  return get<TDefaultTitleGroup[]>(
    baseURL + "/api/contact/getDefaultTitleGroup",
    params,
    { needCache: true, chromeCacheKey: "DefaultTitleGroup" },
    false
  );
}

// 联系人查询状态
export function queryContactStatus(params: any = {}) {
  return get(baseURL + "/api/contact/query_status", params, undefined, true);
}
